import { Redirect, RouteProps } from "react-router";
import SinglePatientRequests from "../pages/MyRequests/SinglePatientRequests";

const patientRoutes: RouteProps[] = [
  {
    path: "/demandes",
    component: SinglePatientRequests,
    exact: true,
  },
  {
    render: () => <Redirect to="/demandes" />,
  },
];

export default patientRoutes;
